import {
	TABS_REMOVE_TAB,
	TABS_RESET,
	CLOSE_ALL_EXCEPT_CURRENT,
	TABS_REVERSE,
	TOGGLE_BLOCK_ADDING_POPUP,
	CLOSE_BLOCK_ADDING_POPUP,
	SET_CURRENT_TAB_FIELD,
	SET_TAB_NAME,
	SET_BREAD_CRUMBS,
	TABS_LOAD_STATE,
	ADD_TABS,
	SET_CURRENT_TAB,
} from 'constants/actions';
import * as api from 'api';
import { unwrapOneShotQuery } from 'api/unwrapOneShotQuery';

export const tabsLoadState = (nextState) => {
	return dispatch => dispatch({
		type: TABS_LOAD_STATE,
		tabs: nextState.tabs,
		current: nextState.current,
	});
};

export function setBreadCrumbs(breadcrumbs) {
	return (dispatch) => {
		dispatch({
			type: SET_BREAD_CRUMBS,
			breadcrumbs,
		});
	};
}

export function setTabName(tab, name) {
	return (dispatch) => {
		dispatch({
			type: SET_TAB_NAME,
			tab,
			name,
		});
	};
}

export function removeTab(payload, redirectConfig) {
	return (dispatch, getState) => {
		const tabType = payload?.tabType;

		if (redirectConfig?.history) {
			const state = getState();
			const tabs = [...(redirectConfig?.tabs || state.tabs.tabs || [])];
			let current = { ...(redirectConfig?.current || state.tabs.current || {}) };

			const removedIndex = tabs.findIndex(v => v.type === tabType);
			const currentIndex = tabs.findIndex(tab => tab.type === current.type);
			if (removedIndex === -1) {
				dispatch({
					type: TABS_REMOVE_TAB,
					payload: { tabType },
				});
				return;
			}

			tabs.splice(removedIndex, 1);

			if (!tabs.length) {
				redirectConfig.history.push('/appeal');
			} else {
				if (removedIndex === currentIndex) {
					current = tabs[tabs.length - 1];
				}

				redirectConfig.history.replace(current.url);
			}
		}

		dispatch({
			type: TABS_REMOVE_TAB,
			payload: { tabType },
		});
	};
}

export function updateCurrentTabRegnum(regnum) {
	return (dispatch) => {
		dispatch({
			type: SET_CURRENT_TAB_FIELD,
			field: 'regnum',
			value: regnum,
		});
	};
}

export const updateCurrentTabField = (field, value) => ({
	type: SET_CURRENT_TAB_FIELD,
	field,
	value,
});

export const resetTab = () => ({
	type: TABS_RESET,
});

export const closeAllExceptCurrent = ({ url }) => ({
	type: CLOSE_ALL_EXCEPT_CURRENT,
	payload: { url },
});

export const tabsReverse = ({ url }) => ({
	type: TABS_REVERSE,
	payload: { url },
});

export const toggleBlockAddingPopup = () => ({
	type: TOGGLE_BLOCK_ADDING_POPUP,
});

export const closeBlockAddingPopup = () => ({
	type: CLOSE_BLOCK_ADDING_POPUP,
});

export const openAppealsFromServer = () => async (dispatch) => {
	const req = dispatch(
		api.mw.appeal.appealOpened.initiate(undefined, {
			forceRefetch: true,
		}),
	);

	return unwrapOneShotQuery(req)
		.then((payload = {}) => {
			const { success, result = [] } = payload || {};

			if (!success || !Array.isArray(result)) {
				return [];
			}

			const ids = result.reduce((acc, cur) => {
				if (cur.open_mode === 'edit') {
					cur.appeals.map(id => acc.push({ id }));
				}

				return acc;
			}, []);

			if (ids.length) {
				dispatch({
					type: ADD_TABS,
					payload: ids,
				});
			}

			return Promise.resolve(ids);
		})
			.catch((err) => {
				console.error('[tabs] openAppealsFromServer failed:', err);
				return [];
			});
	};

export const openAdvancedSearchTab = (idx) => {
	return (dispatch) => dispatch({
		type: SET_CURRENT_TAB,
		tabType: `advanced-search_${idx}`,
		url: `/advanced-search/${idx}/`,
		name: 'advanced-search',
		displayedName: `Розширений пошук #${idx}`,
		queries: {},
	});
};

export const openVideoCallTab = () => {
	return (dispatch) => dispatch({
		type: SET_CURRENT_TAB,
		tabType: 'video-call',
		url: '/video-call',
		name: 'video-call',
		displayedName: 'Відеодзвінок',
		queries: {},
	});
};

export const openCorezoidTab = () => {
	return (dispatch) => dispatch({
		type: SET_CURRENT_TAB,
		tabType: 'corezoid',
		url: '/corezoid',
		name: 'corezoid',
		displayedName: 'sender',
		queries: {},
	});
};

export const openSenderAdminTab = () => {
	return (dispatch) => dispatch({
		type: SET_CURRENT_TAB,
		tabType: 'sender-admin',
		url: '/sender-admin',
		name: 'sender-admin',
		displayedName: 'Sender Admin',
		queries: {},
	});
};

export const setNewCurrentTab = (tab) => {
	return (dispatch) => dispatch({
		type: SET_CURRENT_TAB,
		tabType: tab.type,
		url: tab.url,
		name: tab.name,
		displayedName: tab.displayedName,
		queries: tab.queries,
	});
};
